export const getColumns = () => [
  {
    title: 'METI Code',
    field: 'metiCode',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '150px'
  },
  {
    title: 'SAP Code',
    field: 'sapCode',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '150px'
  },
  {
    title: 'Name',
    field: 'name',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Managing Legal Entity',
    field: 'legalEntity',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Assignments',
    field: 'activeAssignmentsCount',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '180px'
  },
  {
    field: 'isEnabled',
    title: 'Status',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '100px'
  }
]
